<form [formGroup]="settingsForm" class="grid">
  <div class="flex flex-column col-6">
    <div class="flex flex-column gap-6">
      <osp-form-field>
        <osp-label>{{ settingsLimitPercentageLabel }}</osp-label>
        <osp-slider [formControlName]="controlNames.SETTINGS_LIMIT" [min]="0" [max]="100" [step]="1" labelsSuffix="%" />
      </osp-form-field>
    </div>
  </div>
</form>
